import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";
import { TextField, SelectField } from "@syos-music/form";

import { Button, Grid, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUTATION = gql`
  mutation (
    $invoiceId: ID!
    $paymentProvider: PaymentProvider!
    $paymentId: String!
  ) {
    UpdateInvoicePaymentInfos(
      invoiceId: $invoiceId
      paymentProvider: $paymentProvider
      paymentId: $paymentId
    ) {
      invoice {
        id
        paymentProvider
        paymentId
      }
    }
  }
`;

function UpdatePaymentInfos({ invoice, children }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const [updatePaymentInfos] = useMutation(MUTATION);

  return (
    <>
      {!invoice.paymentId && children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={({ paymentProvider, paymentId }) =>
            updatePaymentInfos({
              variables: {
                invoiceId: invoice.id,
                paymentProvider,
                paymentId,
              },
            })
              .then(close)
              .catch(() => true)
          }
          initialValues={{ keptAmount: 0 }}
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting, values }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">
                Modifier les informations de paiement
              </Dialog.Title>

              <Dialog.Content>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <SelectField
                      name="paymentProvider"
                      required
                      label="Moyen de paiement"
                    >
                      <MenuItem value="NONE">Aucun</MenuItem>
                      <MenuItem value="STRIPE">Stripe</MenuItem>
                      <MenuItem value="PAYPAL">Paypal</MenuItem>
                      <MenuItem value="AMAZON">Amazon</MenuItem>
                      <MenuItem value="SUMUP">SumUp</MenuItem>
                      <MenuItem value="TRANSFER">Virement</MenuItem>
                      <MenuItem value="CHECK">Chèque</MenuItem>
                      <MenuItem value="CASH">Liquide</MenuItem>
                    </SelectField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="paymentId"
                      required
                      label="Identifiant de paiement"
                    />
                  </Grid>
                </Grid>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Valider
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}

UpdatePaymentInfos.fragments = {
  invoice: gql`
    fragment Billing_UpdatePaymentInfos_Invoice on Invoice {
      id
      paymentProvider
      paymentId
    }
  `,
};

export default UpdatePaymentInfos;
